import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Fields, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  ButtonGroup,
  InputGroup,
  Radio
} from 'react-bootstrap'
import Button from 'components/Button'
import Toggle from 'components/Toggle'
import CardTemplateField from 'components/CardTemplateField'
import { injectIntl } from 'react-intl'

export class AddAddressForm extends React.Component {
  static propTypes = {
    incomingMailsDomain: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    boardId: PropTypes.number,
  }

  handleInputFocus = (event) => {
    const tempValue = event.target.value
    event.target.value = ''
    event.target.value = tempValue
  }

  renderNameField = ({ name, nameType }) => {
    const {
      incomingMailsDomain
    } = this.props

    return (
      <FormGroup
        validationState={name.meta.touched && name.meta.error ? 'error' : null}
      >
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <Radio
          style={{ marginTop: 0 }}
          name='nameType'
          value='generate'
          checked={nameType.input.value === 'generate'}
          onChange={nameType.input.onChange}
        >
          <FormattedMessage id='INCOMING_EMAILS_NAME_TYPE_GENERATE' />
        </Radio>
        <Radio
          name='nameType'
          value='custom'
          checked={nameType.input.value === 'custom'}
          onChange={nameType.input.onChange}
        >
          <FormattedMessage id='INCOMING_EMAILS_NAME_TYPE_CUSTOM' />
        </Radio>
        {nameType.input.value === 'custom' &&
          <InputGroup>
            <FormattedMessage id='INCOMING_EMAILS_NAME_PLACEHOLDER'>
              {formattedMessage =>
                <FormControl
                  {...name.input}
                  name={null}
                  autoFocus
                  type='text'
                  placeholder={formattedMessage}
                  onFocus={this.handleInputFocus}
                />
              }
            </FormattedMessage>
            <InputGroup.Addon>@{incomingMailsDomain}</InputGroup.Addon>
          </InputGroup>
        }
        {name.meta.touched && name.meta.error && <HelpBlock>{name.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  renderCardTemplateField = (field) => {
    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}
      >
        <CardTemplateField
          boardId={this.props.boardId}
          value={field.input.value}
          onChange={field.input.onChange}
          emptyTitle={this.props.intl.formatMessage({ id: 'INCOMING_EMAILS_CARD_TEMPLATE_NULL' })}
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  renderValidateAddressField = (field) => {
    return (
      <FormGroup>
        <ControlLabel><FormattedMessage id='INCOMING_EMAILS_VALIDATE_ADDRESS_OPTION' /></ControlLabel>
        <div>
          <Toggle
            checked={field.input.value}
            onChange={field.input.onChange}
          />
        </div>
      </FormGroup>
    )
  }

  render () {
    const {
      handleSubmit,
      submitting,
      onCancelClick,
      boardId,
      error,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Fields
          names={['name', 'nameType']}
          component={this.renderNameField}
        />
        {boardId &&
          <Field
            name='cardTemplateId'
            component={this.renderCardTemplateField}
          />
        }
        <Field
          name='validateAddress'
          component={this.renderValidateAddressField}
        />
        <ButtonGroup>
          <Button type='submit' bsStyle='primary' disabled={submitting}><FormattedMessage id='ADD' /></Button>
          <Button onClick={onCancelClick}><FormattedMessage id='CANCEL' /></Button>
        </ButtonGroup>
        {error &&
          <FormGroup
            validationState='error'
          >
            <HelpBlock>{error}</HelpBlock>
          </FormGroup>
        }
      </form>
    )
  }
}

export default injectIntl(reduxForm({
  form: 'addAddress'
})(AddAddressForm))
